import React from 'react'
import Blob2 from '../Assets/blob2.webp'
import Blob3 from '../Assets/blob3.webp'
import Blob4 from '../Assets/blob4.webp'
import Navbar from '../Components/Navbar'
import Top from '../Components/Top'
import CompeListing from '../Components/Competition/CompeListing'
import Footer from '../Components/Footer'
import { useEffect } from 'react'

function CompPage() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
  }, []);    
  return (
    <div className='m-0'>
      <Navbar />
      <Top />
      <div className='mt-[30px] overflow-visible'>
          <div className='z-2  absolute grid grid-cols-3 overflow-hidden'>
            <img src={Blob3} alt="" className='brightness-[200%] scale-[150%] selector'/>
            <img src={Blob4} alt="" className='brightness-[200%] scale-[150%] selector'/>
            <img src={Blob2} alt="" className='brightness-[100%] scale-[150%] selector'/>Z
          </div>
        <div className='z-3 relative mx-auto'>
            <h1 className='text-[bebasNeue] lg:text-[120px] text-[40px] font-[800] text-white opacity-[75%] text-center'>COMPETITIONS</h1>
            <div className='flex flex-wrap gap-4 lg:mx-[100px] mx-[20px]'>
                <CompeListing name={'Badminton'} coverImg={'Badminton.webp'} path={'Badminton'}/>
                <CompeListing name={'Band'} coverImg={'BAND.webp'} path={'Band'}/>
                <CompeListing name={'Basket'} coverImg={'basket.webp'} path={'Basket'}/>
                <CompeListing name={'Business Plan'} coverImg={'business-plan.webp'} path={'Business-Plan'}/>
                <CompeListing name={'English Debate'} coverImg={'eds.webp'} path={'English-Debate'}/>
                <CompeListing name={'Fotografi'} coverImg={'fotografi.webp'} path={'Fotografi'}/>
                <CompeListing name={'Futsal'} coverImg={'futsal.webp'} path={'Futsal'}/>
                <CompeListing name={'JHS IPA'} coverImg={'IPA.webp'} path={'JHS-IPA'}/>
                <CompeListing name={'JHS IPS'} coverImg={'ips.webp'} path={'JHS-IPS'}/>
                <CompeListing name={'JHS Matematika'} coverImg={'Matematika.webp'} path={'JHS-Matematika'}/>
                <CompeListing name={'Modern Dance'} coverImg={'MD.webp'} path={'Modern-Dance'}/>
                <CompeListing name={'Model United Nations'} coverImg={'MUN.webp'} path={'Model-United-Nation'}/>
                <CompeListing name={'Mural'} coverImg={'Mural.webp'} path={'Mural'}/>
                <CompeListing name={'Short Movie Competition'} coverImg={'shortmovie.webp'} path={'Short-Movie'}/>
                <CompeListing name={'Speech Competition'} coverImg={'speech.webp'} path={'Speech-Competition'}/>
                <CompeListing name={'Voli'} coverImg={'Voli.webp'} path={'Voli'}/>
            </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default CompPage